let reduceMotion: boolean = false;
const listeners = new Set<(reduceMotion: boolean) => void>();
let mediaQueryList: MediaQueryList | null = null;

function notifyListeners(): void {
  listeners.forEach((fn) => {
    try {
      fn(reduceMotion);
    } catch (err) {
      console.error('Motion listener failed', err);
    }
  });
}

function handleMediaChange(event: MediaQueryListEvent): void {
  reduceMotion = event.matches;
  notifyListeners();
}

function initMotionPreference(): void {
  if (typeof window === 'undefined' || !window.matchMedia) {
    reduceMotion = false;
    return;
  }

  mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
  reduceMotion = Boolean(mediaQueryList.matches);

  mediaQueryList.addEventListener?.('change', handleMediaChange);
}

function onMotionPreferenceChange(fn: (reduceMotion: boolean) => void): void {
  if (typeof fn !== 'function') return;
  listeners.add(fn);
}

function getReduceMotion(): boolean {
  return reduceMotion;
}

initMotionPreference();

export { getReduceMotion, onMotionPreferenceChange };
